import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Twitter, Mail } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Services',
      links: [
        { label: 'Website Development', href: '#services', isRoute: false },
        { label: 'Web Applications', href: '#services', isRoute: false },
        { label: 'Game Development', href: '#services', isRoute: false },
        { label: 'Educational Games', href: '#services', isRoute: false }
      ]
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', href: '#about', isRoute: false },
        { label: 'Our Projects', href: '#projects', isRoute: false },
        { label: 'Testimonials', href: '#testimonials', isRoute: false },
        { label: 'Contact', href: '#contact', isRoute: false }
      ]
    },
    {
      title: 'Tools',
      links: [
        { label: 'Email Generator', href: '#tools', isRoute: false },
        { label: 'Content Brief Generator', href: '#tools', isRoute: false },
        { label: 'Competitor Analysis', href: '#tools', isRoute: false }
      ]
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy Policy', href: '/privacy-policy', isRoute: true },
        { label: 'Terms & Conditions', href: '/terms-and-conditions', isRoute: true },
        { label: 'Cancellation Policy', href: '/cancellation-policy', isRoute: true },
        { label: 'Delivery Policy', href: '/delivery-policy', isRoute: true },
        { label: 'Contact Us', href: '/contact-us', isRoute: true }
      ]
    }
  ];

  const socialLinks = [
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Mail, href: '#contact', label: 'Email' }
  ];

  return (
    <footer className="footer">
      <div className="container mx-auto px-6">
        {/* Footer Top */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <img src={companyInfo.logo} alt={companyInfo.name} className="h-20 w-auto mb-4" />
            <p className="text-neutral-silver mb-6 max-w-sm">
              {companyInfo.tagline}
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    className="w-10 h-10 rounded-full bg-accent-teal/10 border border-accent-teal/30 flex items-center justify-center hover:bg-accent-teal/20 hover:border-accent-teal transition-all"
                    aria-label={social.label}
                  >
                    <IconComponent size={18} className="text-accent-teal" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Footer Links */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h3 className="text-white font-bold text-lg mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.isRoute ? (
                      <Link
                        to={link.href}
                        className="text-neutral-silver hover:text-accent-teal transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-neutral-silver hover:text-accent-teal transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Footer Bottom */}
        <div className="pt-8 border-t border-neutral-silver/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-neutral-silver text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy-policy" className="text-neutral-silver hover:text-accent-teal transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms-and-conditions" className="text-neutral-silver hover:text-accent-teal transition-colors text-sm">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
